import { Button, Container, Stack, Typography } from "@mui/material";

import Iconify from "src/components/iconify";
import Image from "src/components/image";
import { useResponsive } from "src/hooks/use-responsive";
import { secondaryFont } from "src/theme/typography";


export default function Footer() {

    const isMobile = useResponsive('down', 'sm')

    const handleDownloadApp = () => {
        window.open('https://cidade-center-norte.web.app/SE9NRV9TQ1JFRU5TL2luaWNpbw==')
    }

    return isMobile ?
        (
            <Stack bgcolor='blueBrand.0' py={3}>
                < Container maxWidth='xl' >
                    <Stack spacing={2}>
                        <Typography variant="h5" color='blueBrand.400'>Suas visitas à Cidade Center Norte geram benefícios</Typography>
                        <Image src="/logo/footer_img.png" />
                        <Stack direction='row' alignItems='center' spacing={2} color='redBrand.300'>
                            <Iconify icon='lucide:arrow-down-to-line' width={40} />
                            <Typography variant="h6">Baixe o app Center Norte, faça parte do nosso clube e aproveite.</Typography>
                        </Stack>
                        <Button onClick={handleDownloadApp} variant="contained" color="primary" fullWidth sx={{ borderRadius: 0, p: 2 }}>Baixe o App</Button>
                        <Stack alignItems='center' justifyContent='center'>
                            <Image src="/logo/appstore_google_play.png" width='70%' />
                        </Stack>
                    </Stack>
                </Container >
            </Stack >
        )
        :
        (
            <Stack bgcolor='blueBrand.0' py={10}>
                <Container maxWidth='lg' >
                    <Stack spacing={4}>
                        <Stack alignSelf='flex-start'>
                            <Image src="/logo/viva-cidade-logo.png" width={170} />
                        </Stack>
                        <Typography variant="h3" fontFamily={secondaryFont} fontWeight='bold' color='blueBrand.400'>Suas visitas à Cidade Center Norte geram benefícios.</Typography>
                        <Image src="/logo/footer_img.png" width='40%' alignSelf='center' />
                        <Stack direction='row' justifyContent='space-between'>
                            <Stack direction='row' alignItems='center' spacing={2} color='redBrand.300'>
                                <Iconify icon='lucide:arrow-down-to-line' width={40} />
                                <Typography variant="h6">Baixe o app Center Norte, faça parte do nosso clube e aproveite.</Typography>
                            </Stack>
                            <Button onClick={handleDownloadApp} variant="contained" color="primary" fullWidth sx={{ borderRadius: 0, p: 2, width: '30%' }}>Baixe o App</Button>
                        </Stack>
                    </Stack>
                </Container >
            </Stack >
        )
}